"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.templates = exports.list = exports.mock = exports.get = void 0;
var url_template_1 = __importDefault(require("url-template"));
var order = __importStar(require("./order"));
var reservation = __importStar(require("./reservation"));
var bedbank = __importStar(require("./bedbank"));
var offer = __importStar(require("./offer"));
var calendar = __importStar(require("./calendar"));
var carHire = __importStar(require("./car-hire"));
var flight = __importStar(require("./flight"));
var loyalty = __importStar(require("./loyalty"));
var auth = __importStar(require("./auth"));
var content = __importStar(require("./content"));
var payment = __importStar(require("./payment"));
var search = __importStar(require("./search"));
var tour = __importStar(require("./tour"));
var referral = __importStar(require("./referral"));
var affiliate = __importStar(require("./affiliate"));
var definitions = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ root: "/" }, order), reservation), bedbank), offer), calendar), carHire), flight), loyalty), auth), content), payment), search), tour), referral), affiliate);
function build(rfc6570) {
    var builder = url_template_1.default.parse(rfc6570);
    return {
        expand: function (query) { return builder.expand(query); },
        rfc6570: rfc6570,
    };
}
function get(name) {
    var rfc6570 = definitions[name];
    return build(rfc6570);
}
exports.get = get;
function mock(rfc6570) {
    return build(rfc6570);
}
exports.mock = mock;
function list() {
    return Object.keys(definitions).reduce(function (acc, key) {
        acc[key] = {
            href: get(key).rfc6570,
            templated: true,
        };
        return acc;
    }, {});
}
exports.list = list;
function buildAll(definitions) {
    var templates = Object.keys(definitions).reduce(function (templates, name) {
        templates[name] = build(definitions[name]);
        return templates;
    }, {});
    return templates;
}
exports.templates = {
    root: build("/"),
    order: buildAll(order),
    reservation: buildAll(reservation),
    bedbank: buildAll(bedbank),
    offer: buildAll(offer),
    calendar: buildAll(calendar),
    carHire: buildAll(carHire),
    flight: buildAll(flight),
    loyalty: buildAll(loyalty),
    auth: buildAll(auth),
    content: buildAll(content),
    payment: buildAll(payment),
    search: buildAll(search),
    tour: buildAll(tour),
    referral: buildAll(referral),
    affiliate: buildAll(affiliate),
};
